// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IUserChangePasswordDto
 */
export interface IUserChangePasswordDto {
    /**
     * 
     * @type {string}
     * @memberof IUserChangePasswordDto
     */
    password?: string;
    /**
     * 
     * @type {string}
     * @memberof IUserChangePasswordDto
     */
    new_password?: string;
}

/**
 * Check if a given object implements the IUserChangePasswordDto interface.
 */
export function instanceOfIUserChangePasswordDto(value: object): value is IUserChangePasswordDto {
    return true;
}

export function IUserChangePasswordDtoFromJSON(json: any): IUserChangePasswordDto {
    return IUserChangePasswordDtoFromJSONTyped(json, false);
}

export function IUserChangePasswordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IUserChangePasswordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'password': json['password'] == null ? undefined : json['password'],
        'new_password': json['new_password'] == null ? undefined : json['new_password'],
    };
}

export function IUserChangePasswordDtoToJSON(json: any): IUserChangePasswordDto {
    return IUserChangePasswordDtoToJSONTyped(json, false);
}

export function IUserChangePasswordDtoToJSONTyped(value?: IUserChangePasswordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'password': value['password'],
        'new_password': value['new_password'],
    };
}

